export type AllOption = {
  label: string;
  id: '';
};

export const getAllOption = (selectorLabel: string): AllOption => ({
  label: `All ${selectorLabel}`,
  id: '',
});
